import axios from "@/api";
import { API_URL_SCANNER } from "../../constants/config";
export default {
  fetchTrips({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.page) {
        commit("SET_CURRENT_PAGE", payload.page);
      }
      axios
        .get("/admin/trips/", { params: payload })
        .then((response) => {
          commit("UPDATE_TRIPS", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  fetchTripsMonitor({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/admin/trips/monitor/", { params: payload })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  storeTrip({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/trips/", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  fetchTripsReport({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/admin/trips/`, {
          params: payload,
          headers: {
            responseType: "blob",
          },
          responseType: "blob",
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  MassLoadTrips({ commit }, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/trips/import/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  CheckTripsProgress({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/admin/trips/import/" + payload.task_id + "/progress/", {
          params: payload,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  getTrip({ commit }, payload) {
    console.log("get trip action:", payload);
    if (payload.id) {
      return new Promise((resolve, reject) => {
        axios
          .get("/admin/trips/" + payload.id + "/")
          .then((response) => {
            commit("SET_TRIP_DETAILS", response.data);
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response);
          });
      });
    } else {
      return false;
    }
  },
  updateTrip({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let url = "/admin/trips/" + payload.id + "/";
      delete payload.id;
      axios
        .put(url, payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  deleteTrip({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .delete("/admin/trips/" + payload.id + "/")
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  bulkDeleteTrips({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("/admin/trips/delete/", { ids: payload })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  updateStations({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put("/admin/trips/" + payload.id + "/stations", payload.stations)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  deleteStation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          "/admin/trips/" + payload.id + "/stations/" + payload.station_id
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  finishTrip({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let url = "/admin/trips/" + payload.id + "/actions";
      delete payload.id;
      axios
        .put(url, payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  getOrders({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/admin/orders/`, { params: payload })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  getCheckins({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/admin/trips/` + payload.trip_id + `/checkins/`, {
          params: payload,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  // storeBulkTrips({commit},payload){
  //   return new Promise((resolve, reject)=>{
  //     axios.post('/admin/trips/clone/',payload)
  //       .then(response=>{
  //         resolve(response.data);
  //       })
  //       .catch(error =>{
  //         reject(error.response)
  //       })
  //   })
  // },
  storeBulkTrips({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_URL_SCANNER}v1/trips/clone`, payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
  getTaskProgress({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/admin/trips/clone/${payload.task_id}/progress/`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },
};
